var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fabbricati-id',{attrs:{"isRoot":"","fid":+_vm.fid}})}
var staticRenderFns = []

export { render, staticRenderFns }